import React from "react";
import Breadcrumb from "../ui/Breadcrumb";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

interface PageHeaderProps {
  title: string;
  showBack?: boolean;
  breadcrumbData?: Array<{
    label: string;
    path?: string;
  }>;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  showBack = false,
  breadcrumbData = [],
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col-reverse md:flex-row items-start md:items-center justify-between gap-1">
      <div className="flex items-center gap-2">
        {showBack && (
          <button
            onClick={() => navigate(-1)}
            className="px-2 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-200 rounded flex items-center text-sm"
            aria-label="Back"
          >
            <ArrowLeft size={16} />
          </button>
        )}
        <h1 className="text-ld md:text-xl font-semibold text-gray-800">
          {title}
        </h1>
      </div>

      {breadcrumbData?.length > 0 && <Breadcrumb data={breadcrumbData} />}
    </div>
  );
};

export default PageHeader;
